import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { HeroBlockSearchFormContainer } from '@/components/forms/HeroBlockSearchForm/HeroBlockSearchFormContainer';
import { HeroBlockSearchFormPopoverViewport } from '@/components/forms/HeroBlockSearchForm/HeroBlockSearchFormPopoverViewport';
import { HeroSearchFormActionColumn } from '@/components/forms/HeroBlockSearchForm/components/HeroSearchFormActionColumn';
import { HeroSearchFormDateRangeSelect } from '@/components/forms/HeroBlockSearchForm/fields/HeroSearchFormDateRangeSelect';
import { HeroSearchFormFleetTypeSelect } from '@/components/forms/HeroBlockSearchForm/fields/HeroSearchFormFleetTypeSelect';
import { HeroSearchFormLocationSelect } from '@/components/forms/HeroBlockSearchForm/fields/HeroSearchFormLocationSelect';
import { SearchFromProvider, type SearchFromProviderProps } from '@/components/forms/SearchFromProvider';
import { cn } from '@/lib/cn';
type HeroBlockSearchFormProps = {
  className?: string;
  children?: ReactNode;
  defaultValues?: SearchFromProviderProps['defaultValues'];
};
export function HeroBlockSearchFormFields(t0) {
  const $ = _c(13);
  const {
    className,
    children,
    defaultValues
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <HeroSearchFormFleetTypeSelect title="Vehicle options" description="Select vehicle type" id="fleet-type" />;
    t3 = <HeroSearchFormLocationSelect title="Pick up & drop off location" description="Select pick up & drop off" id="locations" />;
    t4 = <HeroSearchFormDateRangeSelect title="Pick up & drop off dates" description="Select Pick up & drop off dates" id="dates" />;
    t5 = <HeroSearchFormActionColumn />;
    t6 = <HeroBlockSearchFormPopoverViewport />;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] !== children || $[8] !== t1) {
    t7 = <HeroBlockSearchFormContainer className={t1}>{children}{t2}{t3}{t4}{t5}{t6}</HeroBlockSearchFormContainer>;
    $[7] = children;
    $[8] = t1;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== defaultValues || $[11] !== t7) {
    t8 = <SearchFromProvider defaultValues={defaultValues}>{t7}</SearchFromProvider>;
    $[10] = defaultValues;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
}